import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "scene-panel-devices" }
const _hoisted_2 = { class: "d-flex mb-3" }
const _hoisted_3 = { class: "p-input-icon-left ml-auto input-filter-search" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "devices-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_DeviceAndSlotDetail = _resolveComponent("DeviceAndSlotDetail")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          type: "text",
          placeholder: _ctx.$t('AppResource.FilterByText'),
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTerm = $event))
        }, null, 8, ["placeholder", "modelValue"])
      ])
    ]),
    _createVNode(_component_ElScrollbar, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAssignableDevices, (device) => {
            return (_openBlock(), _createBlock(_component_DeviceAndSlotDetail, {
              device: device,
              key: device.id,
              class: "flex-basis-1",
              onAddDevice: _ctx.addDevice,
              "is-add": true,
              isSingleDeviceSelection: _ctx.isSingleDeviceSelection,
              isOnlyDeviceSelection: _ctx.isOnlyDeviceSelection,
              linkableObject: _ctx.linkableObject,
              ruleServiceType: _ctx.ruleServiceType
            }, null, 8, ["device", "onAddDevice", "isSingleDeviceSelection", "isOnlyDeviceSelection", "linkableObject", "ruleServiceType"]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}